













































import { defineComponent, reactive, SetupContext } from '@vue/composition-api';
import { Size } from '@/models/entities/Size';
import SizeDialogContent from '@/components/entities/products/productFields/SizeDialogContent.vue';

interface State {
  headers: any[];
  items: Size[];
  sizeToEdit: Size;
  showEditModal: boolean;
}

interface Props {
  sizes: Size[];
}

const Component = defineComponent({
  name: 'Sizes',
  components: { SizeDialogContent },
  props: {
    sizes: [],
  },

  setup(props: Props, {}: SetupContext) {
    const state = reactive({
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Position', value: 'position', sortable: true },
        {
          text: 'Additional Price',
          value: 'additionalPrice',
          align: 'center',
          sortable: false,
        },
        { text: 'Minimum', value: 'minimumAmount', align: 'center', sortable: false },
        { text: 'Details', value: 'actions', align: 'right', sortable: false },
      ],
      items: props.sizes,
      sizeToEdit: new Size({}),
      showEditModal: false,
    }) as State;

    function saveSize(size: Size) {
      const index = state.items.findIndex(item => item.id === state.sizeToEdit?.id);
      if (index >= 0) {
        Object.assign(state.items[index], size);
        Object.assign(state.sizeToEdit, new Size({}));
        state.items = [...state.items];
      }
      state.showEditModal = false;
    }

    function openSizeEditModal(size: Size) {
      Object.assign(state.sizeToEdit, size);
      state.showEditModal = true;
    }

    function cancelEditSize() {
      Object.assign(state.sizeToEdit, new Size({}));
      state.showEditModal = false;
    }

    return {
      state,
      cancelEditSize,
      saveSize,
      openSizeEditModal,
    };
  },
});
export default Component;
